import { Component, OnInit, inject } from '@angular/core';
import { EnvironmentService } from '../../services';
import { ExternalTool } from '@nx-customer-apps/shared/enums';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-monitored-devices',
    templateUrl: './monitored-devices.component.html',
    imports: [MatButton, ComponentsModule, TranslatePipe]
})
export class MonitoredDevicesComponent implements OnInit {
    private environment = inject(EnvironmentService);

    public url: string;
    public ngOnInit() {
        this.url = this.environment.getExternalUrl(ExternalTool.ViGuide);
    }
}
